export const GET_TRAINING_TYPES = "GET_TRAINING_TYPES"
export const GET_TRAINING_TYPES_FAIL = "GET_TRAINING_TYPES_FAIL"
export const GET_TRAINING_TYPES_SUCCESS = "GET_TRAINING_TYPES_SUCCESS"

export const ADD_NEW_TRAINING_TYPE = "ADD_NEW_TRAINING_TYPE"
export const ADD_TRAINING_TYPE_SUCCESS = "ADD_TRAINING_TYPE_SUCCESS"
export const ADD_TRAINING_TYPE_FAIL = "ADD_TRAINING_TYPE_FAIL"

export const UPDATE_TRAINING_TYPE = "UPDATE_TRAINING_TYPE"
export const UPDATE_TRAINING_TYPE_SUCCESS = "UPDATE_TRAINING_TYPE_SUCCESS"
export const UPDATE_TRAINING_TYPE_FAIL = "UPDATE_TRAINING_TYPE_FAIL"

export const DELETE_TRAINING_TYPE = "DELETE_TRAINING_TYPE"
export const DELETE_TRAINING_TYPE_SUCCESS = "DELETE_TRAINING_TYPE_SUCCESS"
export const DELETE_TRAINING_TYPE_FAIL = "DELETE_TRAINING_TYPE_FAIL"





